export const stripHtml = value => (value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

export const isHtmlEmpty = value => stripHtml(value).length === 0;
